import { render, staticRenderFns } from "./SCardTypeCompanyComp.vue?vue&type=template&id=3f9db463&"
import script from "./SCardTypeCompanyComp.vue?vue&type=script&lang=js&"
export * from "./SCardTypeCompanyComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports